<!-- Staff get the navigation first (they use this page as a jumping-off point);
     customers get the sensor board first (it is what they came for). -->
<div class="container dashboard-area p-3"
     [class.nav-first]="strUserType === arrStrUserTypes[0]"
     *ngIf="bIsLoading">

  <!-- ── Primary: all sensors for this account ── -->
  <div class="landing-section">
    <h5 class="landing-heading">All sensors</h5>
    <app-all-sensors-board></app-all-sensors-board>
  </div>

  <!-- ── The places this dashboard used to link to ── -->
  <div class="landing-section landing-section--nav">
    <h5 class="landing-heading">Go to</h5>

    <mat-card appearance="outlined" class="wrapper">

      <button
        *ngIf="strUserRole === arrStrUserRoles[0]"
        mat-button
        class="btn btn-primary"
        (click)="gotoAdmin()"
      >
        Admins
      </button>

      <button
        *ngIf="strUserType === arrStrUserTypes[0]"
        mat-button
        class="btn btn-success"
        (click)="gotoCustomer()"
      >Customers</button>

      <!-- Both zone routes reject the 'developer' role, so hide the button for it
           rather than bounce the user straight back to this landing page. -->
      <button
        *ngIf="strUserRole !== arrStrUserRoles[1]"
        mat-button
        class="btn btn-warning"
        (click)="gotoZone()"
      >Zones</button>

      <button
        *ngIf="strUserType === arrStrUserTypes[0]"
        mat-button
        class="btn btn-info"
        (click)="gotoSensorList()"
      >Sensors List</button>

      <button
        mat-button
        *ngIf="strUserType === arrStrUserTypes[0]"
        class="btn btn-secondary"
        (click)="gotoSensorTypes()"
      >Sensor Types</button>

      <button
        *ngIf="(strUserType === arrStrUserTypes[0]) && (strUserRole === arrStrUserRoles[0] || strUserRole === arrStrUserRoles[1])"
        mat-button
        class="btn btn-danger"
        (click)="gotoSensorTypeEdit()"
      >Sensor Types Edit</button>

    </mat-card>
  </div>

  <div class="dashboard-version">
    {{version}}
  </div>
</div>
